import React from 'react';
import { SubTitle, Body, Caption, Button, Flex, styled, Currency } from '@teko/ds-desktop';
import { ForwardOutlined } from '@teko/ds-icon';
import { formatDate } from '@teko/utils';
import i18next from 'i18next';
import { t } from '../../i18n.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Shipment = (_a) => {
  var _b = _a, {
    shipment,
    onshowMore
  } = _b, rest = __objRest(_b, [
    "shipment",
    "onshowMore"
  ]);
  var _a2;
  const shipmentStatus = (_a2 = shipment.statusChangeHistories) == null ? void 0 : _a2[0];
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    align: "center",
    justify: "space-between"
  }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SubTitle, {
    weight: "bold",
    color: "textPrimary"
  }, shipment.name, !!shipment.shipmentId && /* @__PURE__ */ React.createElement(React.Fragment, null, ": \xA0", "#", shipment.shipmentId)), shipmentStatus && /* @__PURE__ */ React.createElement(ShipmentStatusWrapper, null, /* @__PURE__ */ React.createElement(Body, {
    color: "link",
    marginBottom: "s4"
  }, shipmentStatus == null ? void 0 : shipmentStatus.status), !!(shipmentStatus == null ? void 0 : shipmentStatus.changedAt) && /* @__PURE__ */ React.createElement(Caption, {
    color: "textSecondary",
    weight: "medium"
  }, formatDate(shipmentStatus == null ? void 0 : shipmentStatus.changedAt, i18next.language || "vi"))), /* @__PURE__ */ React.createElement(Button, {
    variant: "link",
    suffix: /* @__PURE__ */ React.createElement(ForwardOutlined, {
      size: 16
    }),
    onClick: onshowMore
  }, t("Xem chi ti\u1EBFt"))), !!shipment.codAmount && /* @__PURE__ */ React.createElement(Flex, {
    gap: "s4"
  }, /* @__PURE__ */ React.createElement(Body, {
    color: "textSecondary"
  }, t("C\u1EA7n thanh to\xE1n"), ":"), /* @__PURE__ */ React.createElement(SubTitle, {
    color: "primary600",
    weight: "bold"
  }, /* @__PURE__ */ React.createElement(StyledCurrency, {
    value: shipment.codAmount
  }))));
};
const Wrapper = styled(Flex)`
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.colors.divider};
  padding: 0.75rem 1rem;
  width: 100%;
`;
const ShipmentStatusWrapper = styled.div`
  position: relative;
  padding: 1px 1rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;

  &::before {
    content: '';
    position: absolute;
    top: 6px;
    left: 4px;
    width: 1px;
    height: 80%;
    border-left: 1.5px solid ${({ theme }) => theme.colors.divider};
    transform: translateX(-50%);
  }
  &::after {
    top: 4px;
    content: '';
    position: absolute;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.link};
    border: 1px solid ${({ theme }) => theme.colors.divider};
  }
`;
const StyledCurrency = styled(Currency)`
  font-size: unset;
`;

export { Shipment };
